import {Logo, Socials, Link, Partner} from '../../components'
import {useMediaQuery} from 'react-responsive';
import cn from 'classnames';
import styles from './Hero.module.scss';
import pic from '../../resources/pics/hero.jpg';

export const Hero = ({handler}) => {
    const isMobile = useMediaQuery({ query: `(max-width: 768px)` });

    return (
        <div className={styles.hero}>
            <div className={styles.hero}>
                <div className={styles.info}>
                    <div className={styles.header}>
                        <Logo color={'dark'}/>
                        <Partner color={isMobile ? 'white' : 'green'}/>
                    </div>
                    <div className={styles.content}>
                        <div className={cn(styles.title, 'h1')}>Вложи в меня, если сможешь</div>
                        <p className={cn(styles.paragraph, 'text-body')}>Учимся извлекать выгоду из драгоценных металлов без алхимии, но с весёлой игрой от 2x2</p>
                        <Link tag={'div'} text={'Правила игры'} onClick={handler} />
                    </div>
                </div>
                <div className={styles.pic}>
                    <img src={pic} alt='Коллекция коллекционеров'/>
                </div>
                <div className={styles.social}>
                    <Socials/>
                </div>
            </div>
        </div>
    );
};
